import * as images from "@/components/images/Images";
import type { ServicePlanCardProps } from "@/components/screen/global-components/services/ServicePlanCard";
import { ROUTES } from "@/constants";

const servicesTranslationPromptCardsQuality: ServicePlanCardProps[] = [
  {
    title: "Standard Translation",
    image: images.solar_buildings1,
    price: "<span>$0.10</span>&nbsp;/ per word",
    description:
      "Our intelligent platform matches your project to an expert translator specialized in your language pair and use case. Get precision and accuracy across a variety of formats when you don’t require a certificate.",
    mainButton: "Start Order",
    mainButtonLink: ROUTES.startOrder,
    secondaryButton: "Learn more",
    secondaryButtonLink: "#",
  },
  {
    title: "Certified Translation",
    image: images.solar_buildings2,
    price: "<span>$24.50</span>&nbsp;/ page",
    description:
      "Receive a word-for-word translation from an accredited translator, which comes with a dated, and signed certification statement as required by universities, courts, and government agencies. Express delivery, notarization, and mailed hard copies available.",
    mainButton: "Start Order",
    mainButtonLink: ROUTES.startOrder,
    secondaryButton: "Learn more",
    secondaryButtonLink: "#",
  },
  {
    title: "Enterprise",
    image: images.solar_buildings3,
    price: "Custom for pricing",
    description:
      "Custom-fit our document translation services to your business. This fully managed offering empowers seamless order and delivery across any complexity or volume of translations.",
    mainButton: "Get  a quote",
    secondaryButton: "Learn more",
    mainButtonLink: ROUTES.getQuote,
    secondaryButtonLink: "#",
    highlight: "accent", 
  },
];

const contentQuality = {
  title: "Which translation service do you need?",
  description:
    "Get your documents translated within 24 hours by elite native-speaking translators who specialize in your use case across 100+ languages.",
} as const;

export const servicesTranslationPromptMap = {
  quality: {
    content: contentQuality,
    cards: servicesTranslationPromptCardsQuality,
  },
};
